import { Button, Flex, Form, Input, message, Modal, Space } from "antd"
import { UserAddOutlined } from "@ant-design/icons"
import { useState } from "react"
import SelectAccessPage from "./SelectAccessPage"
import SelectRoles from "./SelectRole"
import { createNewCustomer } from "../api/customersApi"
import { useActions } from "../../../hooks/useActions"
import Password from "./Password"
import UserDataModal from "./UserDataModal"

interface IUserData {
  fullName: string
  email: string
  phoneNumber: string
  password: string
  accessesPages: [string]
  roles: [string]
}

const AddUser = ({}) => {
  const [form] = Form.useForm()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isLoginDataOpen, setIsLoginDataOpen] = useState<boolean>(false)
  const [userLoginData, setUserLoginData] = useState<{ email: string; password: string }>({
    email: "",
    password: "",
  })

  const { fetchCustomers } = useActions()

  function openModalWindow() {
    setIsOpen(true)
  }

  function onFinish(values: IUserData) {
    setUserLoginData({
      email: values.email,
      password: values.password,
    })

    createNewCustomer(values)
      .then((res) => {
        message.success("Created success")
        setIsLoginDataOpen(true)
        fetchCustomers()
      })
      .catch((e) => {
        message.error("Created error")
      })
      .finally(() => {
        setIsOpen(false)
      })
  }

  const onRolesChange = (value: string[]) => {
    form.setFieldsValue({ roles: value })
  }

  const onAccessPagesChange = (value: string[]) => {
    form.setFieldsValue({ accessesPages: value })
  }

  const setPassword = (value: string) => {
    form.setFieldsValue({ password: value })
  }

  return (
    <>
      <Button
        icon={<UserAddOutlined />}
        color="primary"
        variant="outlined"
        onClick={openModalWindow}
      >
        Create User
      </Button>

      <Modal
        title="Create User"
        open={isOpen}
        okText={"Save"}
        onCancel={() => setIsOpen(false)}
        onOk={() => form.submit()}
      >
        <Flex vertical gap="10px">
          <Form form={form} name="control-hooks" onFinish={onFinish} style={{ maxWidth: 600 }}>
            <Form.Item name="fullName" label="Full Name" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="email" label="Email" rules={[{ required: true }]}>
              <Input />
            </Form.Item>

            <Form.Item name="phoneNumber" label="Phone Number" rules={[{ required: false }]}>
              <Input />
            </Form.Item>

            <Form.Item name="accessesPages" label="Access Pages" rules={[{ required: true }]}>
              <SelectAccessPage
                accesesPage={form.getFieldValue("accessesPages")}
                setAccesesPage={onAccessPagesChange}
              />
            </Form.Item>

            <Form.Item name="roles" label="Roles" rules={[{ required: true }]}>
              <SelectRoles roles={form.getFieldValue("roles")} setRoles={onRolesChange} />
            </Form.Item>

            <Form.Item name="password" label="Password" rules={[{ required: true }]}>
              <Password setFormPassword={setPassword} />
            </Form.Item>
          </Form>
        </Flex>
      </Modal>

      <UserDataModal
        open={isLoginDataOpen}
        email={userLoginData.email}
        password={userLoginData.password}
      />
    </>
  )
}

export default AddUser
